// extracted by mini-css-extract-plugin
export default {"container":"fp-z","brandName":"gp-z","productName":"hp-z","aboveGalleryInfo":"ip-z","belowGalleryInfo":"jp-z","breakLongProductName":"kp-z"};